interface Time {

    time: number
    simulationTime: number
    simulationDeltaTime: number
    maxDeltaTime: number
    deltaTime: number
}

export interface GlobalState {

    time: Time
}

type System<T> = ((obj: T) => void)

interface Systems<T> {
    init: System<T>[],
    present: System<T> [],
    simulate: System<T>[]
}

export function runLoop<T extends GlobalState>(systems: Systems<T>, globals = {} as T) {
    systems = Object.assign({}, {
        init: [],
        present: [],
        simulate: []
    }, systems)

    systems.init = arrayIfy(systems.init)
    systems.present = arrayIfy(systems.present)
    systems.simulate = arrayIfy(systems.simulate)

    const time: Time = {
        time: 0,
        simulationTime: 0,
        simulationDeltaTime: 1 / 60,
        maxDeltaTime: 1 / 60,// 0.3,
        deltaTime: 1 / 60
    }

    Object.assign(globals, {
        time: time
    })

    const mainLoop = systemTime => {

        const prevTime = time.time
        time.time = systemTime / 1000
        time.deltaTime = time.time - prevTime
        time.deltaTime = Math.min(time.deltaTime, time.maxDeltaTime)

        let simCount = 0
        while (time.simulationTime + time.simulationDeltaTime <= time.time)
        {
            simCount++
            systems.simulate.forEach(s => s(globals))
            time.simulationTime += time.simulationDeltaTime
        }

        systems.present.forEach(s => s(globals))

        requestAnimationFrame(mainLoop)
    };

    (async () => {
        for (const s of systems.init) {
            await s(globals);
        }

        requestAnimationFrame(mainLoop)
    })()

    return globals
}


function arrayIfy(arrayOrNot) {
    return Array.isArray(arrayOrNot) ? arrayOrNot : [arrayOrNot]
}
